import {DeltaEventMethodType} from "../../../gd/manager/delta-handler/types";
import Resources from "../../resources";


export function checkMeetingRelevance(resources:Resources, method: DeltaEventMethodType, data:any, header:any) {


    switch (method) {
        case DeltaEventMethodType.NEW   :

            // filter out meetings from other projects
            if (resources.relevanceSettings?.projects) {
                if (!resources.relevanceSettings.projects.includes(data.projectId)) {
                    return false
                }
            }

            return true

        case DeltaEventMethodType.DELTA:
        case DeltaEventMethodType.DELETE:

            // if we have no resource we can't delete it...
            return !!resources.meetings?.get(header.meeting.id)

    }


}